import { ToursCatalog } from 'package-types';

export class TourOperatorsState {
  tourOperators: ToursCatalog.SiteTourOperator[] = [];
}
